<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/download.svg" size="2"></app-svg>

  <h1>Download All</h1>
  <p>Your <b>{{totalKb | dataUnits : 1 : 2}}</b> download needs to be split across multiple ZIP-files. Are you sure you
    want to download everything?</p>

  <button appButton name="download" location="download-all-dialog" color="primary" (click)="close(true)" height="4" size="3"
    weight="bold" spacing="full">Download All</button>

  <button appButton name="individual" location="download-all-dialog" color="simple-gray" (click)="close('am')" size="3" height="1"
    weight="bold" class="sub-cta" [center]="true" *ngIf="amAllowed">Select Individual</button>

  <button appButton name="cancel" location="download-all-dialog" color="simple-gray" (click)="close(false)" size="3" height="1"
    weight="bold" class="sub-cta" [center]="true" *ngIf="!amAllowed">Cancel</button>
</div>
